import {Component, Inject, Input, OnInit} from '@angular/core';
import {WIZARD_DATA} from "../../../../tokens/tokens";
import {PasoWizard} from "../../../../interface/wizard-informacion.types";

@Component({
    selector: 'confirmacion-registro',
    templateUrl: './confirmacion-registro.component.html',
    styleUrls: ['./confirmacion-registro.component.css']
})
export class ConfirmacionRegistroComponent implements OnInit {

    paso: PasoWizard;

    @Input()
    config: PasoWizard;

    constructor(@Inject(WIZARD_DATA) public data: any) {
        this.paso = data.paso;
    }

    ngOnInit(): void {
        console.log(this.paso);
    }

}
